const FIRAQ_SUPABASE_URL = 'https://upponfojjwharqjpxlrm.supabase.co';
const FIRAQ_SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVwcG9uZm9qandoYXJxanB4bHJtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODAzMzQ4ODksImV4cCI6MjA5NTkxMDg4OX0.vu_WyJRUgOsoBfX698OdDzMwUIJ4ePh3zFFD3msW_6M';

declare const supabase: any;

export class FiraqWidget extends HTMLElement {
    private firaqSb: any;
    private mode: string | null = null;
    private date: string | null = null;
    private draftTitle: string | null = null;
    private draftDesc: string | null = null;
    private facts: string | null = null;
    private issues: string | null = null;
    private rules: string | null = null;
    private application: string | null = null;
    private questions: string | null = null;
    private category: string | null = null;

    private container!: HTMLDivElement;

    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        
        if (typeof supabase !== 'undefined') {
            this.firaqSb = supabase.createClient(FIRAQ_SUPABASE_URL, FIRAQ_SUPABASE_KEY);
        }
        
        this.renderBase();
    }

    static get observedAttributes() {
        return ['mode', 'date', 'title', 'desc', 'facts', 'issues', 'rules', 'application', 'questions', 'category'];
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (newValue) {
            if (name === 'mode') this.mode = newValue;
            if (name === 'date') this.date = newValue;
            if (name === 'title') this.draftTitle = decodeURIComponent(newValue);
            if (name === 'desc') this.draftDesc = decodeURIComponent(newValue);
            if (name === 'facts') this.facts = decodeURIComponent(newValue);
            if (name === 'issues') this.issues = decodeURIComponent(newValue);
            if (name === 'rules') this.rules = decodeURIComponent(newValue);
            if (name === 'application') this.application = decodeURIComponent(newValue);
            if (name === 'questions') this.questions = decodeURIComponent(newValue);
            if (name === 'category') this.category = decodeURIComponent(newValue);
            
            this.executeAction();
        }
    }

    renderBase() {
        this.shadowRoot!.innerHTML = `
            <style>
                :host {
                    display: block;
                    width: 100%;
                    max-width: 500px;
                    margin: 15px 0;
                    font-family: var(--font-family, system-ui, sans-serif);
                }
                .widget-card {
                    background: #111827; 
                    border: 1px solid #374151;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 4px 15px rgba(0,0,0,0.3);
                }
                .header {
                    background: #1F2937;
                    padding: 12px 16px;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    color: #fff;
                    border-bottom: 1px solid #374151;
                }
                .logo {
                    width: 24px;
                    height: 24px;
                    background: #2563EB;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    font-weight: bold;
                    color: #fff;
                }
                .title {
                    font-weight: 600;
                    font-size: 14px;
                }
                .body {
                    padding: 16px;
                    color: #E5E7EB;
                }
                .firaq-section {
                    margin-bottom: 12px;
                }
                .firaq-label {
                    font-weight: 600;
                    color: #60A5FA;
                    font-size: 11px;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    margin-bottom: 4px;
                }
                .content-box {
                    background: rgba(0,0,0,0.2);
                    padding: 10px;
                    border-radius: 6px;
                    font-size: 13px;
                    line-height: 1.5;
                    border: 1px solid #374151;
                    white-space: pre-wrap;
                }
                .btn {
                    background: #2563EB;
                    color: #fff;
                    border: none;
                    padding: 10px 16px;
                    border-radius: 6px;
                    font-weight: 600;
                    cursor: pointer;
                    width: 100%;
                    transition: opacity 0.2s;
                    margin-top: 10px;
                }
                .btn:hover {
                    opacity: 0.9;
                }
                .badge {
                    display: inline-block;
                    background: #374151;
                    padding: 4px 8px;
                    border-radius: 4px;
                    font-size: 12px;
                    margin-bottom: 10px;
                    color: #9CA3AF;
                }
                .login-warning {
                    font-size: 12px;
                    color: #FBBF24;
                    margin-top: 10px;
                    text-align: center;
                }
            </style>
            <div class="widget-card">
                <div class="header">
                    <div class="logo"><i class="fas fa-gavel"></i></div>
                    <div class="title" id="widgetTitle">LEGAL-FIRAQ Assistant</div>
                </div>
                <div class="body" id="widgetBody">
                    Loading context...
                </div>
            </div>
        `;
        this.container = this.shadowRoot!.getElementById('widgetBody') as HTMLDivElement;
    }

    async executeAction() {
        if (!this.mode) return;

        const { data: { session } } = await this.firaqSb.auth.getSession();
        
        if (this.mode === 'draft-event') {
            this.renderDraftEvent(session);
        } else if (this.mode === 'draft-case') {
            this.renderDraftCase(session);
        } else if (this.mode === 'memory') {
            this.renderMemory(session);
        }
    }

    renderDraftCase(session: any) {
        const title = this.shadowRoot!.getElementById('widgetTitle')!;
        title.textContent = 'Drafted Legal Case';

        let html = '';
        html += `<div class="firaq-section"><div class="firaq-label">Case Name</div><div class="content-box">${this.draftTitle || 'Untitled Case'}</div></div>`;
        html += `<div class="firaq-section"><div class="firaq-label">Description</div><div class="content-box">${this.draftDesc || 'No description provided.'}</div></div>`;

        if (session) {
            html += `<button class="btn" id="saveBtn">Create Case in LEGAL-FIRAQ</button>`;
        } else {
            html += `
                <button class="btn" onclick="window.open('https://firaq.9rk.pages.dev', '_blank')">Open LEGAL-FIRAQ</button>
                <div class="login-warning">Log in to create this case.</div>
            `;
        }

        this.container.innerHTML = html;

        const saveBtn = this.shadowRoot!.getElementById('saveBtn');
        if (saveBtn) {
            saveBtn.addEventListener('click', () => this.saveCase(session));
        }
    }

    renderDraftEvent(session: any) {
        const title = this.shadowRoot!.getElementById('widgetTitle')!;
        title.textContent = 'Drafted FIRAQ Entry';

        let html = '';
        if (this.date) html += `<div class="badge">📅 ${this.date}</div>`;
        if (this.category) html += ` <div class="badge">🏷️ ${this.category}</div>`;

        html += `<div class="firaq-section"><div class="firaq-label">Title</div><div class="content-box">${this.draftTitle || 'Untitled Event'}</div></div>`;
        
        const sections = [
            { id: 'facts', label: 'Facts', val: this.facts },
            { id: 'issues', label: 'Issues', val: this.issues },
            { id: 'rules', label: 'Rules', val: this.rules },
            { id: 'application', label: 'Application', val: this.application },
            { id: 'questions', label: 'Questions', val: this.questions },
            { id: 'desc', label: 'Notes', val: this.draftDesc }
        ];

        sections.forEach(sec => {
            if (sec.val) {
                html += `<div class="firaq-section"><div class="firaq-label">${sec.label}</div><div class="content-box">${sec.val}</div></div>`;
            }
        });

        if (session) {
            html += `<button class="btn" id="saveBtn">Save FIRAQ Entry</button>`;
        } else {
            html += `
                <button class="btn" onclick="window.open('https://firaq.9rk.pages.dev', '_blank')">Open LEGAL-FIRAQ</button>
                <div class="login-warning">Log in to save this entry automatically.</div>
            `;
        }

        this.container.innerHTML = html;

        const saveBtn = this.shadowRoot!.getElementById('saveBtn');
        if (saveBtn) {
            saveBtn.addEventListener('click', () => this.saveEvent(session));
        }
    }

    async renderMemory(session: any) {
        const title = this.shadowRoot!.getElementById('widgetTitle')!;
        title.textContent = `Case Memories ${this.date ? '(' + this.date + ')' : ''}`;

        if (!session) {
            this.container.innerHTML = `
                <div style="text-align:center; padding: 20px;">
                    <p>I need access to your cases to retrieve memories.</p>
                    <button class="btn" onclick="window.open('https://firaq.9rk.pages.dev', '_blank')">Login to LEGAL-FIRAQ</button>
                </div>
            `;
            return;
        }

        this.container.innerHTML = '<i>Searching case archives...</i>';

        try {
            let query = this.firaqSb.from('firaq_events').select('*, firaq_cases(name)').eq('user_id', session.user.id);
            
            if (this.date) {
                query = query.like('date', `${this.date}%`);
            }
            
            query = query.order('date', { ascending: false }).limit(3);

            const { data, error } = await query;

            if (error) throw error;

            if (data && data.length > 0) {
                let html = '<div style="display:flex; flex-direction:column; gap:10px;">';
                data.forEach((entry: any) => {
                    const dateStr = new Date(entry.date).toLocaleDateString();
                    html += `
                        <div class="content-box" style="margin:0;">
                            <strong style="color:#60A5FA;">${dateStr} - ${entry.firaq_cases?.name || 'General'}</strong><br/>
                            <div style="font-weight:600; margin-top:4px;">${entry.title}</div>
                            ${entry.facts ? '<div style="margin-top:4px; font-size:11px; opacity:0.8;">F: ' + entry.facts.substring(0, 100) + '...</div>' : ''}
                        </div>
                    `;
                });
                html += '</div>';
                this.container.innerHTML = html;
            } else {
                this.container.innerHTML = 'No entries found for this time period.';
            }
        } catch (e: any) {
            this.container.innerHTML = `<div style="color:#ef4444;">Error fetching memories: ${e.message}</div>`;
        }
    }

    async saveCase(session: any) {
        const btn = this.shadowRoot!.getElementById('saveBtn') as HTMLButtonElement;
        btn.textContent = 'Saving...';
        btn.disabled = true;

        try {
            const { error } = await this.firaqSb.from('firaq_cases').insert({
                user_id: session.user.id,
                name: this.draftTitle || 'Untitled Case',
                description: this.draftDesc || ''
            });

            if (error) throw error;
            btn.textContent = 'Case Created!';
            btn.style.background = '#10B981';
        } catch (e: any) {
            btn.textContent = 'Error Saving';
            btn.style.background = '#EF4444';
            console.error(e);
        }
    }

    async saveEvent(session: any) {
        const btn = this.shadowRoot!.getElementById('saveBtn') as HTMLButtonElement;
        btn.textContent = 'Saving...';
        btn.disabled = true;

        try {
            // Pick the latest case if none exists, or create a default one
            let caseId;
            const { data: cases } = await this.firaqSb.from('firaq_cases').select('id').eq('user_id', session.user.id).order('created_date', { ascending: false }).limit(1);
            
            if (cases && cases.length > 0) {
                caseId = cases[0].id;
            } else {
                const { data: newCase } = await this.firaqSb.from('firaq_cases').insert({
                    user_id: session.user.id,
                    name: 'General AI Case Log'
                }).select();
                caseId = newCase[0].id;
            }

            const { error } = await this.firaqSb.from('firaq_events').insert({
                user_id: session.user.id,
                case_id: caseId,
                title: this.draftTitle || 'AI Drafted Event',
                category: this.category || 'general',
                date: this.date ? new Date(this.date).toISOString() : new Date().toISOString(),
                description: this.draftDesc || '',
                facts: this.facts || '',
                issues: this.issues || '',
                rules: this.rules || '',
                application: this.application || '',
                questions: this.questions || ''
            });

            if (error) throw error;
            btn.textContent = 'Entry Saved!';
            btn.style.background = '#10B981';
        } catch (e: any) {
            btn.textContent = 'Error Saving';
            btn.style.background = '#EF4444';
            console.error(e);
        }
    }
}

export function initFiraqBridge() {
    if (!customElements.get('firaq-widget')) {
        customElements.define('firaq-widget', FiraqWidget);
    }
}
